export default __webpack_public_path__ + "static/media/AW3.43a8621b.jpg";